import { render, staticRenderFns } from "./BasicInfoCard.vue?vue&type=template&id=c75d2e50&scoped=true"
import script from "./BasicInfoCard.vue?vue&type=script&lang=js"
export * from "./BasicInfoCard.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoCard.vue?vue&type=style&index=0&id=c75d2e50&prod&lang=scss&scoped=true"
import style1 from "./BasicInfoCard.vue?vue&type=style&index=1&id=c75d2e50&prod&lang=scss&scoped=true"
import style2 from "./BasicInfoCard.vue?vue&type=style&index=2&id=c75d2e50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75d2e50",
  null
  
)

export default component.exports